/**
 * 请求封装
 * 1、参数说明
 *   a、method: 默认为post类型【可选】
 *   b、url: 请求地址【必填】
 *   c、body: 请求参数【可选】
 *   d、timeout: 超时时间，默认8000ms【可选】
 * 2、使用说明
 *   a、已封装了统一处理的事务，并返回promise对象，业务层可使用promise API
 */

import axios from 'axios'
import qs from 'qs'
import cookie from 'js-cookie'
import urlTool from '@common/url'

const request = ({ method = 'post', url, body = {}, head = {}, timeout = 8000, headers = {} }) => {
  try {
    if (!url) {
      throw new Error('Request url is null!')
    }
  } catch (e) {
    return Promise.reject(e)
  }

  // 页面域名与接口域名对应（兼容多域名访问）
  // 目前需要兼容feidee.com, ssjlicai.com双域名
  const currentDomain = urlTool('domain')
  const apiDomain = urlTool('domain', url)
  let ensureUrl = url
  if (currentDomain !== apiDomain) {
    ensureUrl = url.replace(apiDomain, currentDomain)
  }

  // 参数封装
  const params = {
    head: {
      // uid: '1100011226', // 用户id，正式环境中由接口在cookie中提取
      clientId: cookie.get('clientId') || '', // 渠道id，(01：随管家，04：随手记，12：H5)
      appUDID: window.FDMarketMeta ? window.FDMarketMeta.UUID : '',  // 客户端设备id，由客户端注入
      appVersion: cookie.get('appVersion') || '', // 客户端版本号，由客户端注入
      channelId: cookie.get('channelId') || '',
      innerMedia: cookie.get('lc_inner_media') || '',
      outerMedia: cookie.get('lc_outer_media') || '',
      subClientId: cookie.get('lc_sub_client') || '',
      origin: cookie.get('account_open_origin') || '', // 开户渠道统计
      ...head,
    },
    body
  }

  const ssjToken = cookie.get('ssj_token')
  if (ssjToken) {
    headers.Authorization = `Bearer ${ssjToken}`
  }
  const options = {
    url: ensureUrl,
    method,
    timeout,
    withCredentials: !(process.env.NODE_ENV === 'dev'),
    headers
  }

  if (method === 'get') {
    options.params = {
      params: JSON.stringify(params)
    }
  } else {
    options.data = qs.stringify({
      params: JSON.stringify(params)
    })
  }

  return axios(options).then((result) => {
    return Promise.resolve(result.data)
  }).catch((error) => {
    if (error.message.indexOf('timeout') !== -1) {
      return Promise.reject('数据请求超时，请稍后再试')
    } else if (error.message.indexOf('Network Error') !== -1) {
      return Promise.reject('世界上最遥远的距离，就是没有网络')
    } else if (error.response) {
      switch (error.response.status) {
        case 401:
          try {
            const errorData = JSON.parse(error.response.data)
            if ([65283, 65280].indexOf(errorData.code) > -1) {
              return Promise.resolve({ succeed: false, msg: errorData.message, code: errorData.code })
            }
          } catch (jsonError) {
            console.log(jsonError)
          }
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  })
}

export default {
  request
}



// WEBPACK FOOTER //
// ./node_modules/@finance/ajax-oauth2/src/index.js